import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-final-c-t-a',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './final-c-t-a.component.html',
  styleUrls: ['./final-c-t-a.component.scss']
})
export class FinalCTAComponent {}
